/*
 * @Description: 企点产品订单
 * @Author: 杨志航
 * @Date: 2026-05-27 11:25:07
 */
import React, { useEffect, useState } from 'react'
import {
  Input,
  InputNumber,
  Form,
  Row,
  Col,
  Select,
  Button,
  Icon,
} from 'antd'
import api from '@/api'

const FormItem = Form.Item
const { Option } = Select
let id = 1

const CompanyPoint = props => {
  const { oaidObj, accountObj, detail, mediaList, contractData, form } = props
  const { getFieldDecorator, setFieldsValue, getFieldValue } = form
  const [productList, setProductList] = useState([])

  useEffect(() => {
    async function fetchData() {
      const { productInfo } = contractData
      if (productInfo && productInfo.length > 0) {
        const newKeys = productInfo.map((_, index) => index)
        id = productInfo.length
        setFieldsValue({ productKeys: newKeys }, () => {
          // 由于 setFieldsValue 是异步的，所以需要使用 callback 来确保在设置值之前，表单已经渲染完成
          newKeys.forEach(key => {
            setFieldsValue({ 
              [`project[${key}]`]: productInfo[key].project,
              [`product[${key}]`]: productInfo[key].product,
              [`productAlias[${key}]`]: productInfo[key].productAlias,
              [`subscriptionType[${key}]`]: productInfo[key].subscriptionType,
              [`workNumber[${key}]`]: productInfo[key].workNumber,
              [`price[${key}]`]: productInfo[key].price,
            })
          })
        })
        // 获取每个项目的产品列表
        for (let i = 0; i < productInfo.length; i++) {
          const { project } = productInfo[i]
          const data = await api.getsysProjectChilds({ pid: project.split('|')[0] })
          productList.push(data)
        }
        setProductList([...productList])
      } else {
        setProductList([[]])
        setFieldsValue({ productKeys: [0] })
      }
    }
    fetchData()
  }, [contractData])

  const changeProject = (val, key, index) => {
    setFieldsValue({ [`product[${key}]`]: undefined })
    api.getsysProjectChilds({ pid: val.split('|')[0] }).then(data => {
      productList.splice(index, 1, data)
      setProductList([...productList])
    })
  }

  const handleAdd = () => {
    const productKeys = getFieldValue('productKeys')
    const newKeys = [...productKeys, id++]
    setFieldsValue({ productKeys: newKeys })
    productList.push([])
    setProductList([...productList])
  }

  const handleRemove = index => {
    const productKeys = getFieldValue('productKeys')
    const newKeys = productKeys.filter((key, i) => i !== index)
    setFieldsValue({ productKeys: newKeys })
    productList.splice(index, 1)
    setProductList([...productList])
  }

  getFieldDecorator('productKeys', { initialValue: [] })
  const productKeys = getFieldValue('productKeys')

  const formItems = productKeys.map((key, index) => {
    return (
      <Row gutter={24} key={index}> 
        <Col span={4}> 
          <FormItem label="投放媒体">
            {getFieldDecorator(`project[${key}]`, {
              rules: [{ required: true, message: '请选择' }],
            })(
              <Select
                placeholder="请选择"
                dropdownMatchSelectWidth={false}
                showSearch
                optionFilterProp="children"
                onChange={val => changeProject(val, key, index)}
              >
                {mediaList.map((i, v) => (
                  <Option
                    key={v}
                    value={`${i.id}|${i.name}`}
                  >
                    {i.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem label="产品">
            {getFieldDecorator(`product[${key}]`, {
              rules: [{ required: true, message: '请选择' }],
            })(
              <Select
                placeholder="请选择"
                dropdownMatchSelectWidth={false}
                showSearch
                optionFilterProp="children"
              >
                {productList[index]?.map((i, v) => (
                  <Option
                    key={v}
                    value={`${i.id}|${i.name}`}
                  >
                    {i.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem label="产品别名">
            {getFieldDecorator(`productAlias[${key}]`, {
              rules: [{ required: true, message: '请输入产品别名' }],
            })(<Input placeholder="请输入产品别名" />)}
          </FormItem>
        </Col>
        <Col span={3}>
          <FormItem label="订阅类型">
            {getFieldDecorator(`subscriptionType[${key}]`, {
              rules: [{ required: true, message: '请输入订阅类型' }],
            })(<Input placeholder="请输入订阅类型" />)}
          </FormItem>
        </Col>
        <Col span={4}>
          <FormItem label="工号数量">
            {getFieldDecorator(`workNumber[${key}]`, {
              rules: [{ required: true, message: '请输入工号数量' }],
            })(<InputNumber 
              placeholder="请输入工号数量（或应用个数）" 
              precision={0}
              step={1}
              min={0}
              style={{ width: '100%' }}
            />)}
          </FormItem>
        </Col>
        <Col span={3}>
          <FormItem label="价格">
            {getFieldDecorator(`price[${key}]`, {
              rules: [{ required: true, message: '请输入价格' }],
            })(<InputNumber 
              placeholder="请输入价格" 
              precision={2}
              step={0.01}
              min={0}
              style={{ width: '100%' }}
            />)}
          </FormItem>
        </Col>
        {productKeys.length > 1 && (
          <Col span={2}>
            <Icon
              type="minus-circle-o"
              style={{ fontSize: '24px', marginTop: '48px', color: '#FF4D4F' }}
              onClick={() => handleRemove(index)}
            />
          </Col>
        )}
      </Row>
    )
  })

  return (
    <>
      <div className="line"></div>
      <h3 className="apply-tit">双方公司信息</h3>
      <div className="underline"></div>
      <Row gutter={24}>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>甲方（委托方）</div>
        </Col>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>乙方（服务提供方）</div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{oaidObj.name ? oaidObj.name : detail.partA}</div>
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.fullName ? accountObj.fullName : detail.partB}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="联系人" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('contactA', {
              rules: [{ required: true, message: '请输入甲方联系人' }]
            })(<Input placeholder="请输入甲方联系人" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="联系方式" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('mobileA', {
              rules: [{ required: true, message: '请输入甲方联系电话' }]
            })(<Input placeholder="请输入甲方联系电话" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
        </Col>
      </Row>
      <div className="line"></div>
      <h3 className="apply-tit" style={{ marginTop: '40px' }}>产品信息与订阅期间</h3>
      <div className="underline" style={{ marginBottom: '16px' }}></div>
      <div style={{padding: '20px', color: '#333333', fontSize: '16px'}}>产品信息</div>
      {formItems}
      <Button type="primary" icon="plus" block style={{ margin: '20px 0'}} onClick={handleAdd}>添加产品</Button>
      <Row gutter={24}>
        <Col span={24}>
          <FormItem label="订阅期间" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('subscriptionPeriod', {
              rules: [{ required: true, message: '请输入订阅期间' }]
            })(<Input.TextArea placeholder="请输入订阅期间" rows={4} />)}
          </FormItem>
        </Col>
      </Row>
    </>
  )
}

export default CompanyPoint